var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgKeyboardArrowUp24Px = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.94 5.47125L4 2.41792L7.06 5.47125L8 4.53125L4 0.53125L0 4.53125L0.94 5.47125Z",
    fill: "#696F88"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKeyboardArrowUp24Px);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/keyboard_arrow_up_24px.a70801b055be9cf2a5316cf4964b03e6.svg";